var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cc-editor-min',{model:{value:(_vm.form['introduction']),callback:function ($$v) {_vm.$set(_vm.form, 'introduction', $$v)},expression:"form['introduction']"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }